import React, { FC, useEffect, useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

interface InfoHelpDialogProps {
  open: boolean;
  onClose: () => void;
}

const InfoHelpDialog: FC<InfoHelpDialogProps> = ({ open, onClose }) => {
  const [scroll] = useState<DialogProps['scroll']>('paper');

  const descriptionElementRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">VEJLEDNING TIL BRUG AF INFOMODUL</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <div id="descriptiontext">
            I infomodulet kan I selv ændre og tilføje forskellige typer skærmbilleder på p-automaterne.

            <ul>
              <li>"Ude af drift"- billedet vises uafbrudt, så længe automaten er i status ude af drift.</li>
              <li>”Pauseskærm” - fungerer som en forside, og vises på skærmen, når automaten ikke har været i brug i ca. 15 sekunder. 
                Header og statusbar vises som normalt.</li>
                <li>”Reklame” - billedet skjuler header, og der tilføjes en "Tryk for parkering"-knap i bunden af skærmen, udover det 
                  fungerer den på samme måde som "Pauseskærm".</li>
            </ul>

            Billeder kan ikke redigeres via dette system, men skal redigeres i et billedbehandlingsprogram først.
            <br />
            <br />
            <div id="frontpagedescription">
              <b>
                <span id="frontpagedescriptionheadline">
                  SÅDAN TILFØJES BILLEDER TIL GALLERIET
                </span>
              </b>
              <ul>
                <li>Klik først på "Rediger", hvorefter der kommer en "Tilføj billede" knap over billederne.</li>
                <li>Klik på ”Tilføj billede”. Et nyt vindue åbner, hvor et billede kan tilføjes.</li>
                <li>OBS! Billedets filformat skal være jpg eller png.</li>
                <li>Billedstørrelse maks.:</li>
                <ul>
                  <li>Ude af drift - bredde x højde: 1024 x 768 pixels.</li>
                  <li>Pauseskærm - bredde x højde: 1024 x 645 pixels.</li>
                  <li>Reklame - bredde x højde: 1024 x 630 pixels.</li>
                </ul>
                <li>Billedet gemmes som en af følgende billedtyper:</li>
                <ul>
                  <li>"Ude af drift", ”Pauseskærm” eller ”Reklame”</li>
                </ul>
              </ul>

              <b>
                <span id="frontpagedescriptionheadline">
                  SÅDAN ÆNDRES: UDE AF DRIFT/REKLAMER/PAUSESKÆRM
                </span>
              </b>
              <ul>
                <li>Klik på knappen "Rediger", som findes øverst på siden i billedgalleriet.</li>
                <li>
                  Marker det ønskede billede i billedegalleriet.
                </li>
                <li>
                  Tilvælg de ønskede automater, som billede skal være aktivt på.
                </li>
                <li>Klik på "Gem".</li>
              </ul>
              <p>
              Et vindue vil åbne, hvor du vil blive spurgt om du vil opdatere nu.
              <br/><b>"OPDATER NU":</b> Ændringerne træder i kraft på automaten med det samme.
              <br/><b>"OPDATER VED MIDNAT":</b> Ændringerne vil være gældende efter den natlige genstart af automaten.
              </p>
              <p>
                En automat kan enten have et aktivt pauseskærmsbillede eller et aktivt reklamebillede. Ikke begge dele samtidig.
                Hvis automaten har et aktivt reklamebillede, og man herefter vælger at aktivere et pauseskærmsbillede,
                vil pauseskærmsbilledet erstatte reklamebilledet.
                <br/>
              </p>

              <p>
                ”Ude af drift”-billederne sættes på den enkelte automat via Mobilbasen, når automaten sættes ud af drift.
              </p>

              <span>
              <b>Hvis et billede ikke længere skal være aktivt</b>
              </span>
              <ul>
                <li>Klik på knappen "Rediger", som findes øverst på siden i billedgalleriet.</li>
                <li>Marker det ønskede billede.</li>
                <li>Fjern markeringen fra de automater, du ikke ønsker billedet skal være aktivt på.</li>
                <li>Hvis du ønsker at deaktivere billedet på alle automater, kan du klikke på "Fravælg alle", som fjerner markeringen fra alle automater.</li>
                <li>Klik herefter på "Gem".</li>
              </ul>
            </div>
            <div id="eventcreation">
              <br /><b>
                <span id="frontpagedescriptionheadline">
                  SÅDAN OPRETTER DU ET EVENT
                </span>
              </b>
              <p>
              Hvis der skal vises en ude af drift-skærm, pauseskærm eller reklame i en afgrænset periode, kan dette oprettes som et event.
              Når eventet er slut, går alle typer skærme tilbage til de oprindelige billeder, automaten blev leveret med.
              OBS! Hvis man ønsker et andet billede at gå tilbage til, efter eventets afslutning, kan man sætte et standardbillede af samme
              type, som billedet, der indgår i eventet. Det kan man ved at klikke på "Sæt som standard", ved siden af det billede, som man
              ønsker som standardbillede.
              </p>
              <ul>
                <li>Klik på "Tilføj Event".</li>
                <li>
                  Et vindue kommer frem hvori startdato, slutdato,
                  hvilket billede man ønsker at påføre et event og
                  hvilke automater eventet skal være aktivt på, udfyldes/vælges.
                </li>
                <li>
                  Billedtypen bestemmer eventtypen.
                  <br /><br />OBS! Hvis man opretter et ude-af drift-event, definerer man alene,
                  hvilket billede skal vises på skærmen i den angivne periode.
                  Automaten sættes ikke automatisk ud af drift (eller tilbage i drift igen. Dette skal gøres i Mobilbasen).
                  <br />
                  <br />
                </li>
                <li>Klik på "Fuldfør" og eventet oprettes.</li>
              </ul>
              <p>
                Eventet kan slettes ved at klikke på "Slet event" knappen, øverst til højre for billedet.
              </p>
            </div>
            <div id="slideshowcreation">
              <br /><b>
                <span id="frontpagedescriptionheadline">
                  SÅDAN OPRETTER DU ET SLIDESHOW
                </span>
              </b>
              <p>
              Hvis du ønsker at automaten skal veksle mellem flere forskellige reklamebilleder eller pauseskærmsbilleder, 
              kan du oprette et slideshow.
              </p>
              <ul>
                <li>Klik på "Rediger".</li>
                <li>Klik herefter på "Tilføj Slideshow".</li>
                <li>
                  Et vindue kommer frem, hvori man udfylder varighed af billedfremvisning, billedtype,
                  hvilke billeder man ønsker at fremvise i et slideshow, og hvilke automater slideshowet skal være aktivt på.
                </li>
                <li>
                  Du kan ikke blande billeder på tværs af billedtyper - dvs. et slideshow er enten af typen "Reklame" eller "Pauseskærm".
                  <br />Én automat kan kun have et slideshow aktivt ad gangen.
                  <br />Varigheden af billedefremvisning, skal være mellem 10 og 60 sekunder.
                </li>
                <li>Klik på "Fuldfør" og slideshowet oprettes.</li>
              </ul>
              <p>
                For at deaktivere et slideshow, skal du deaktivere de aktive billeder, der indgår i slideshowet.
                <br />Du kan se en liste over automater, hvor et billede er aktivt, under "Rediger" siden.
              </p>
            </div>
          </div>
          {/* </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Luk
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InfoHelpDialog;
